
export function filterAsync<T>(arr: T[], promiser: (val: T) => Promise<boolean>): Promise<T[]> {
    const arrayOrig = arr;

    return new Promise(async function(resolve, reject) {
        try {
            const newArray: T[] = [];

            for ( let idx=0; idx<arrayOrig.length; idx++ ) {
                const val = arrayOrig[idx];
                const shouldAdd = await promiser(val);
                if ( shouldAdd ) {
                    newArray.push(val);
                }
            }

            resolve(newArray);
        } catch (error) {
            reject(error);
        }
    });
}
